import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const orig = error.config;
    if (
      error.response?.status === 401 &&
      orig &&
      !orig._retried &&
      !orig.url.includes("/auth/")
    ) {
      orig._retried = true;
      try {
        await api.post("/auth/refresh");
        return api(orig);
      } catch {
        /* session gone */
      }
    }
    return Promise.reject(error);
  }
);

export const usd = (n) =>
  `$${Number(n).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export function preorderLabel(p, t) {
  if (p.arrival_date) {
    const d = new Date(`${p.arrival_date}T00:00:00`);
    const date = Number.isNaN(d.getTime())
      ? p.arrival_date
      : d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
    return `${t("preorder")} · ${t("arrives")} ${date}`;
  }
  return `${t("preorder")}${p.lead_time ? ` · ${p.lead_time}` : ""}`;
}

export const imgUrl = (u) =>
  u && u.startsWith("/api/")
    ? `${process.env.REACT_APP_BACKEND_URL}${u}`
    : u;

export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.url;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

let cachedCountry = null;

async function getCountry() {
  if (cachedCountry) return cachedCountry;
  cachedCountry = sessionStorage.getItem("kinos_country");
  if (cachedCountry) return cachedCountry;
  try {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), 3000);
    const res = await fetch("https://ipapi.co/json/", { signal: ctrl.signal });
    clearTimeout(timer);
    const data = await res.json();
    cachedCountry = data.country_name || "Unknown";
  } catch {
    cachedCountry = "Unknown";
  }
  sessionStorage.setItem("kinos_country", cachedCountry);
  return cachedCountry;
}

function detectDevice() {
  const ua = navigator.userAgent;
  if (/tablet|ipad/i.test(ua)) return "Tablet";
  if (/mobi|android|iphone/i.test(ua)) return "Mobile";
  return "Desktop";
}

function getVisitorId() {
  let v = localStorage.getItem("kinos_visitor_id");
  if (!v) {
    v = crypto.randomUUID();
    localStorage.setItem("kinos_visitor_id", v);
  }
  return v;
}

export async function trackVisit(path, productId = null) {
  try {
    const country = await getCountry();
    api.post("/analytics/track", {
      path,
      device: detectDevice(),
      country,
      visitor_id: getVisitorId(),
      ...(productId ? { product_id: productId } : {}),
    });
  } catch {
    /* analytics must never break the app */
  }
}
